import { StatelessAccordion as BaseUiAccordion, Panel } from 'baseui/accordion'
import classNames from 'classnames'
import React, { Key, useEffect } from 'react'
import { OverlaySpinner } from '..'
import { WemoloTypography } from '../Wemolo'
import './Accordion.css'
import styles from './Accordion.module.css'

export const Accordion = ({
    title,
    children,
    initialExpandState,
    disabled,
    isLoading = false,
    backgroundColor
}: {
    title?: string
    children: React.ReactNode
    initialExpandState: boolean
    disabled?: boolean
    isLoading?: boolean
    backgroundColor?: string
}) => {
    const [expanded, setExpanded] = React.useState<Key[]>(() => {
        if (initialExpandState) {
            return ['0']
        } else {
            return []
        }
    })

    const styledChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            const typedChild = child as React.ReactElement<{ className?: string }>
            return React.cloneElement(typedChild, {
                className: classNames(styles.child, typedChild.props.className)
            })
        }
        return child
    })

    useEffect(() => {
        if (disabled) {
            setExpanded([])
        } else {
            setExpanded(initialExpandState ? ['0'] : [])
        }
    }, [disabled, initialExpandState])

    return (
        <div className={styles.root}>
            <BaseUiAccordion
                expanded={expanded}
                disabled={disabled}
                onChange={({ expanded }) => {
                    setExpanded(expanded)
                }}
            >
                <Panel
                    overrides={{
                        Header: {
                            style: {
                                paddingTop: '10px',
                                paddingBottom: '6px',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                borderBottom: '1px solid #eeeeee',
                                backgroundColor: backgroundColor ? backgroundColor : '#f6f6f6',
                                color: 'black !important'
                            }
                        },

                        Content: {
                            style: {
                                paddingTop: '15px',
                                paddingBottom: '15px',
                                paddingLeft: '10px',
                                paddingRight: '10px'
                            }
                        }
                    }}
                    title={
                        <WemoloTypography variant="body-large-emphasized" tag="span">
                            {title}
                        </WemoloTypography>
                    }
                >
                    {isLoading ? (
                        <OverlaySpinner>
                            <div>{styledChildren}</div>
                        </OverlaySpinner>
                    ) : (
                        <div>{styledChildren}</div>
                    )}
                </Panel>
            </BaseUiAccordion>
        </div>
    )
}
